import * as THREE from "three";

THREE.ColorManagement.legacyMode = false;

/**
 * Geometries
 */
export const boxGeometry = new THREE.BoxGeometry(1, 1, 1);

/**
 * Materials
 */
export const limeGreenMaterial = new THREE.MeshStandardMaterial({ color: "limegreen" });
export const greenYellowMaterial = new THREE.MeshStandardMaterial({ color: "greenyellow" });
export const orangeRedMaterial = new THREE.MeshStandardMaterial({ color: "orangered" });
export const slateGreyMaterial = new THREE.MeshStandardMaterial({ color: "slategrey" });
export const redMaterial = new THREE.MeshStandardMaterial({ color: "red", emissive: "red", emissiveIntensity: 7 });